















































































import {
  Vue,
  Component,
  Prop
} from "@/shared/vuepack";
import { Validator } from "vee-validate";
import { claimHsabAccount } from "@/shared/api/userService";
import SupportCard from "@/shared/components/SupportCard.vue";
import Button from "@/shared/components/ui/Button.vue";
import LoginWrapper from "@/shared/components/ui/LoginWrapper.vue";
import { LoginRouteNames } from "@/shared/loginRoutes";
import { isMobileApp } from "@/shared/mobileHelper";
import { useNotifierStore } from "@/shared/store/notifier";
import { useUserStore } from "@/shared/store/user";
import { useCredentialFlowStore } from "@/employee/store/credentialFlow";
import { OktaCredential } from "@/employee/route-names";


@Component({
  components: {
    Button,
    LoginWrapper,
    SupportCard
  }
})
export default class HsabClaimAccountVerify extends Vue {
  $validator: Validator;
  notifierStore = useNotifierStore();

  userStore = useUserStore();
  credentialFlowStore = useCredentialFlowStore();

  OktaCredential = OktaCredential;

  isSubmitting = false;
  password = "";
  confirmPassword = "";
  username = "";
  showStartOverButton = false;

  @Prop()
  routeToLogin;

  get submitDisabled () {
    return this.isSubmitting;
  }

  get confirmPasswordValidation () {
    return {
      required: !!this.password,
      confirmed: !!this.confirmPassword && this.password
    };
  }

  mounted () {
    if (!this.credentialFlowStore.credentialFlowUsername) {
      this.$router.push({ name: LoginRouteNames.OktaLogin });
    }
  }

  onSubmit () {
    this.isSubmitting = true;
    this.$validator.validateAll()
        .then(result => {
          if (!result) {
            this.isSubmitting = false;
            return;
          }

          this.verifyAccount();
        });
  }

  verifyAccount () {
    this.showStartOverButton = false;

    claimHsabAccount({
      bendUserId: this.credentialFlowStore.bendUserId,
      identityProofingOptionType: this.credentialFlowStore.selectedIdentityOption.optionType,
      username: this.username,
      password: this.password,
      email: this.credentialFlowStore.email,
      signature: this.credentialFlowStore.signature,
      isMobileApp: isMobileApp()
    })
        .then(() => {
          this.userStore.setLoginUsername(this.username);
          this.$router.push(this.routeToLogin);
          this.notifierStore.setSuccess("Thank you for setting up your password. You may now log in.");
        })
        .catch(err => {
          const errMsg = this.getErrorMessage(err);
          this.showStartOverButton = true;
          this.notifierStore.setDanger(errMsg);
        })
        .finally(() => {
          this.isSubmitting = false;
        });
  }

  getErrorMessage (err: any) {
    return err && err.response && err.response.data && err.response.data.errorMessage
        ? err.response.data.errorMessage
        : "Something went wrong.";
  }

  togglePasswordMask (inputId: string) {
    const passwordField = document.getElementById(inputId);

    if (passwordField.getAttribute("type") === "password") {
      passwordField.setAttribute("type", "text");
    } else {
      passwordField.setAttribute("type", "password");
    }
  }
}
